import { Directive, ElementRef, HostListener } from '@angular/core';
import { TELEPHONE_REGEX } from '../helpers/constants';
@Directive({
    selector: '[dianaTelephoneInput]',
    standalone: false
})
/**
 * Used to force only positive numbers in the inputs
 */
export class TelephoneInputDirective {

  private regex: RegExp = TELEPHONE_REGEX;
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    const input = this.el.nativeElement;
    const currentValue = input.value;
    const selectionStart = input.selectionStart || 0;
    const selectionEnd = input.selectionEnd || 0;
    const nextValue = currentValue.slice(0, selectionStart) + event.key + currentValue.slice(selectionEnd);


    // if (!this.regex.test(nextValue)) {
    //   event.preventDefault();
    // }
  }
}